import React from 'react';
import { useNavigate } from 'react-router-dom';

const Footer = ({ t }) => {
  const navigate = useNavigate();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-brand">
            <h3 className="footer-logo">KRYPTON9</h3>
            <p className="body-medium text-secondary">{t.footer.tagline}</p>
          </div>
          
          <div className="footer-links">
            <button onClick={() => navigate('/privacy')} className="footer-link body-small" data-testid="footer-privacy-link">
              {t.footer.links.privacy}
            </button>
            <button onClick={() => navigate('/terms')} className="footer-link body-small" data-testid="footer-terms-link">
              {t.footer.links.terms}
            </button>
            <button onClick={() => navigate('/cookies')} className="footer-link body-small" data-testid="footer-cookies-link">
              {t.footer.links.cookies}
            </button>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p className="caption">{t.footer.copyright}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
